import React from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const TranslatedLabel = _ref => {
  let {
    i18nKey,
    values,
    as: Component,
    className
  } = _ref;
  const {
    t
  } = useTranslation();
  const text = t(i18nKey, values);
  const tooltip = t(i18nKey, {
    ns: 'tooltips',
    defaultValue: '',
    ...values
  });
  if (!tooltip) {
    return Component ? /*#__PURE__*/React.createElement(Component, {
      className: className
    }, text) : text;
  }
  const Wrapper = Component || 'span';
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: `tooltip-${i18nKey}`
    }, tooltip)
  }, /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, text));
};
export default TranslatedLabel;